module.exports = function (Colors, Segment, Utils) {
    'use strict';
    function WaveformSegments(peaks) {
        this._peaks = peaks;
        this._segments = [];
        this._segmentsById = {};
        this._segmentIdCounter = 0;
        this._colorIndex = 0;
    }
    WaveformSegments.prototype._getNextSegmentId = function () {
        return 'peaks.segment.' + this._segmentIdCounter++;
    };
    var colors = [
        Colors.navy,
        Colors.blue,
        Colors.aqua,
        Colors.teal,
        Colors.yellow,
        Colors.orange,
        Colors.red,
        Colors.maroon,
        Colors.fuchsia,
        Colors.purple
    ];
    WaveformSegments.prototype._getSegmentColor = function () {
        if (this._peaks.options.randomizeSegmentColor) {
            if (++this._colorIndex === colors.length) {
                this._colorIndex = 0;
            }
            return colors[this._colorIndex];
        } else {
            return this._peaks.options.segmentColor;
        }
    };
    WaveformSegments.prototype._addSegment = function (segment) {
        this._segments.push(segment);
        this._segmentsById[segment.id] = segment;
    };
    WaveformSegments.prototype._createSegment = function (options) {
        if (!Utils.isObject(options)) {
            throw new TypeError('peaks.segments.add(): expected a Segment object parameter');
        }
        var segment = new Segment(this, Utils.isNullOrUndefined(options.id) ? this._getNextSegmentId() : options.id, options.startTime, options.endTime, options.labelText || '', options.color || this._getSegmentColor(), options.editable || false);
        return segment;
    };
    WaveformSegments.prototype.getSegments = function () {
        return this._segments;
    };
    WaveformSegments.prototype.getSegment = function (id) {
        return this._segmentsById[id] || null;
    };
    WaveformSegments.prototype.getSegmentsAtTime = function (time) {
        return this._segments.filter(function (segment) {
            return time >= segment.startTime && time < segment.endTime;
        });
    };
    WaveformSegments.prototype.find = function (startTime, endTime) {
        return this._segments.filter(function (segment) {
            return segment.isVisible(startTime, endTime);
        });
    };
    WaveformSegments.prototype.add = function (segmentOrSegments) {
        var self = this;
        var segments = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
        if (typeof segments[0] === 'number') {
            this._peaks.options.deprecationLogger('peaks.segments.add(): expected a segment object or an array');
            segments = [{
                    startTime: arguments[0],
                    endTime: arguments[1],
                    editable: arguments[2],
                    color: arguments[3],
                    labelText: arguments[4]
                }];
        }
        segments = segments.map(function (segmentOptions) {
            var segment = self._createSegment(segmentOptions);
            if (Object.prototype.hasOwnProperty.call(self._segmentsById, segment.id)) {
                throw new Error('peaks.segments.add(): duplicate id');
            }
            return segment;
        });
        segments.forEach(function (segment) {
            self._addSegment(segment);
        });
        this._peaks.emit('segments.add', segments);
    };
    WaveformSegments.prototype._findSegment = function (predicate) {
        var indexes = [];
        for (var i = 0, length = this._segments.length; i < length; i++) {
            if (predicate(this._segments[i])) {
                indexes.push(i);
            }
        }
        return indexes;
    };
    WaveformSegments.prototype._removeIndexes = function (indexes) {
        var removed = [];
        for (var i = 0; i < indexes.length; i++) {
            var index = indexes[i] - removed.length;
            var itemRemoved = this._segments.splice(index, 1)[0];
            delete this._segmentsById[itemRemoved.id];
            removed.push(itemRemoved);
        }
        return removed;
    };
    WaveformSegments.prototype._removeSegments = function (predicate) {
        var indexes = this._findSegment(predicate);
        var removed = this._removeIndexes(indexes);
        this._peaks.emit('segments.remove', removed);
        return removed;
    };
    WaveformSegments.prototype.remove = function (segment) {
        return this._removeSegments(function (s) {
            return s === segment;
        });
    };
    WaveformSegments.prototype.removeById = function (segmentId) {
        return this._removeSegments(function (segment) {
            return segment.id === segmentId;
        });
    };
    WaveformSegments.prototype.removeByTime = function (startTime, endTime) {
        endTime = typeof endTime === 'number' ? endTime : 0;
        var fnFilter;
        if (endTime > 0) {
            fnFilter = function (segment) {
                return segment.startTime === startTime && segment.endTime === endTime;
            };
        } else {
            fnFilter = function (segment) {
                return segment.startTime === startTime;
            };
        }
        return this._removeSegments(fnFilter);
    };
    WaveformSegments.prototype.removeAll = function () {
        this._segments = [];
        this._segmentsById = {};
        this._peaks.emit('segments.remove_all');
    };
    return WaveformSegments;
}(require('colors.css'), require('peaks/markers/segment'), require('peaks/waveform/waveform.utils'));